import type { SWRConfiguration } from 'swr';

export const DEFAULT_SWR_OPTIONS: SWRConfiguration = {
  revalidateIfStale: true,
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  refreshInterval: 0,
  shouldRetryOnError: true,
  dedupingInterval: 0,
};

export const PAGINATED_SWR_OPTIONS: SWRConfiguration = {
  ...DEFAULT_SWR_OPTIONS,
  keepPreviousData: true,
  revalidateOnFocus: false,
  revalidateOnMount: true,
}; 